export default name => {
    const nameRegex = /^[-a-zA-Z.' ]*[-a-zA-Z.']+[-a-zA-Z.' ]{0,100}$/;
    const isValid = nameRegex.test(String(name || "").toLowerCase());
    return isValid;
};
